import { StudyDocument } from "@/src/pages/study/types";
import { Tooltip, TooltipContent, TooltipProvider } from "../ui/tooltip";
import { Button } from "../ui/button";
import { TooltipArrow, TooltipTrigger } from "@radix-ui/react-tooltip";
import { FileText } from "lucide-react";
import { cn } from "@/lib/utils";

export const SelectedSourcesPill: React.FC<{
  selectedSources: StudyDocument[];
}> = ({ selectedSources }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="sm"
            disabled={selectedSources.length === 0}
            className={cn(
              "h-8 rounded-full px-3 text-xs font-medium shadow-none",
              "flex items-center gap-1.5 hover:bg-theme-2",
              selectedSources.length === 0
                ? "opacity-50"
                : "bg-theme-1 text-theme-0"
            )}
          >
            <FileText className="h-3.5 w-3.5" />
            <span>
              Using {selectedSources.length} selected{" "}
              {selectedSources.length === 1 ? "source" : "sources"}
            </span>
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="center"
          className="bg-theme-2"
          sideOffset={5}
          variant="theme"
        >
          <p className="text-sm">Select sources in the left sidebar!</p>
          <TooltipArrow className="fill-bg-theme-2" />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
